import { render, staticRenderFns } from "./budget-user-start-sign-modal.vue?vue&type=template&id=5b44dacd&scoped=true&"
import script from "./budget-user-start-sign-modal.vue?vue&type=script&lang=ts&"
export * from "./budget-user-start-sign-modal.vue?vue&type=script&lang=ts&"
import style0 from "./budget-user-start-sign-modal.vue?vue&type=style&index=0&id=5b44dacd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b44dacd",
  null
  
)

export default component.exports